import { useState } from "react";
import { Reveal } from "./Reveal";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Please fill in all fields.");
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.post("/contact", form);
      toast.success(data.message || "Thank you!");
      setForm({ name: "", email: "", message: "" });
    } catch {
      toast.error("Could not send your message. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" className="py-24 md:py-32 bg-surface">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-5">
          <Reveal>
            <p className="text-xs tracking-[0.3em] uppercase text-clay mb-6">Get in touch</p>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-serif font-light text-4xl sm:text-5xl tracking-tight text-ink leading-[1.05]">
              Have a question?<br />We'd love to hear from you.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 text-muted leading-relaxed max-w-md">
              Whether you're planning your first retreat or returning for renewal, our team is here
              to help you find the right experience.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <p className="mt-8 font-serif text-2xl text-forest">hello@soundbodyretreat.com</p>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <Reveal delay={0.15}>
            <form onSubmit={submit} className="space-y-8" data-testid="contact-form">
              <div className="grid sm:grid-cols-2 gap-8">
                <input
                  data-testid="contact-name-input"
                  type="text"
                  placeholder="Name"
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  className="w-full bg-transparent border-b border-line py-3 text-lg focus:outline-none focus:border-forest transition-colors"
                />
                <input
                  data-testid="contact-email-input"
                  type="email"
                  placeholder="Email"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  className="w-full bg-transparent border-b border-line py-3 text-lg focus:outline-none focus:border-forest transition-colors"
                />
              </div>
              <textarea
                data-testid="contact-message-input"
                placeholder="Tell us what you're looking for…"
                rows={4}
                value={form.message}
                onChange={(e) => setForm({ ...form, message: e.target.value })}
                className="w-full bg-transparent border-b border-line py-3 text-lg focus:outline-none focus:border-forest transition-colors resize-none"
              />
              <button
                type="submit"
                disabled={loading}
                data-testid="contact-submit-btn"
                className="rounded-full bg-forest text-sand px-8 py-4 text-sm hover:bg-forest-deep transition-colors inline-flex items-center gap-2 disabled:opacity-60"
              >
                {loading ? (
                  <>
                    <Loader2 size={16} className="animate-spin" /> Sending…
                  </>
                ) : (
                  "Send message"
                )}
              </button>
            </form>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
